import React from 'react';
import PropTypes from 'prop-types';

import withTranslate from '../../hoc/with-translate';
import { preventDefault } from '../../services/click-handling';
import { Button } from '../button';
import { FollowOrChatButton } from '../follow-or-chat-button';
import styles from './action-buttons.scss';

const classNames = require('classnames');

export class ActionButtons extends React.Component {
  renderLinkToMyProfile() {
    const { member, goToMemberPage, t, linkClassName, showChat, showFollowButton } = this.props;

    if (!showChat && !showFollowButton) {
      return null;
    }

    return (
      <Button
        dataHook="my-profile-link"
        onClick={preventDefault(() => goToMemberPage(member.uid))}
        className={classNames(
          linkClassName,
          'ma-secondary-button',
          'ma-members-button-font-secondary',
          styles.myProfileButton,
          'ma-all-members-buttons-corner-radius',
        )}
      >
        {t('members-page.my-profile')}
      </Button>
    );
  }

  renderFollowOrChatButton() {
    const {
      member,
      t,
      linkClassName,
      showFollowButton,
      showChat,
      currentMemberUid,
      followOrUnfollow,
      handleChat,
    } = this.props;

    return (
      <FollowOrChatButton
        isFollowing={member.isSubscribed}
        shouldShowChatButton={showChat && member.uid !== currentMemberUid}
        followText={t('profile-widget.follow')}
        unfollowText={t('profile-widget.unfollow')}
        chatText={t('profile-widget.message')}
        textFontClass="ma-pw-button-font"
        primaryButtonClass={classNames(linkClassName, 'ma-pw-primary-button', 'ma-primary-button')}
        secondaryButtonClass={classNames(linkClassName, 'ma-secondary-button', 'ma-fill-primary-text')}
        dataHook={member.isSubscribed ? 'unfollow-link' : 'follow-link'}
        onFFClick={preventDefault(() => followOrUnfollow(member.uid))}
        onChatClick={() => handleChat(member.uid)}
        size="medium"
        showFollowButton={showFollowButton}
      />
    );
  }

  render() {
    const { member, currentMemberUid, containerClassName } = this.props;
    let actionButton;
    if (member.uid === currentMemberUid) {
      actionButton = this.renderLinkToMyProfile();
    } else {
      actionButton = this.renderFollowOrChatButton();
    }

    return <div className={containerClassName}>{actionButton}</div>;
  }
}

ActionButtons.propTypes = {
  member: PropTypes.object.isRequired,
  currentMemberUid: PropTypes.string,
  followOrUnfollow: PropTypes.func.isRequired,
  goToMemberPage: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  containerClassName: PropTypes.string,
  linkClassName: PropTypes.string,
  handleChat: PropTypes.func,
  showChat: PropTypes.bool,
  showFollowButton: PropTypes.bool,
};

export default withTranslate(ActionButtons);
